import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import Multiselect from "multiselect-react-dropdown";
import { eiwrsKitSchemaManagementServices } from "../../../../APIServices/EIWRS/KitManagement/eiwrsKitSchemaManagementServices";

const UpdateStudyKitSchemaManagement = ({
  kitSchemaData,
  getEIWRSKitSchemaManagementData,
  Show,
  Hide,
  Title,
  setKitSchemaId,
}) => {
  const { studyId } = useParams()
  const [schemaName, setSchemaName] = useState("");
  const [kitPrefix, setKitPrefix] = useState("");
  const [kitStartingNumber, setKitStartingNumber] = useState("");
  const [kitSufix, setKitSufix] = useState("");
  const [kitJoiner, setKitJoiner] = useState("");
  const [buttonLoader, setButtonLoader] = useState(false);

  const updateEIWRSKitSchemaManagementData = async (e) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to Update Schema Name!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.id = kitSchemaData?._id;
        userData.studyId = studyId;
        userData.schemaName = schemaName;
        userData.kitPrefix = kitPrefix;
        userData.kitStartingNumber = kitStartingNumber;
        userData.kitSuffix = kitSufix;
        userData.kitJoiner = kitJoiner;
        let data = await eiwrsKitSchemaManagementServices.updateEIWRSKitSchemaManagementData(
          userData
        );
        if (data?.statusCode === 200) {
          getEIWRSKitSchemaManagementData();
          Hide();
          setKitSchemaId("");
          setSchemaName("");
          setKitPrefix("");
          setKitStartingNumber("");
          setKitSufix("");
          setKitJoiner("");
        }
      }
      setButtonLoader(false);
    });
  };

  useEffect(() => {
    setSchemaName(kitSchemaData?.schemaName || "");
    setKitPrefix(kitSchemaData?.kitPrefix || "");
    setKitStartingNumber(kitSchemaData?.kitStartingNumber || "");
    setKitSufix(kitSchemaData?.kitSufix || "");
    setKitJoiner(kitSchemaData?.kitJoiner || "");
  }, [kitSchemaData]);
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">
              Schema Name{" "}
              <abbr title="Required" className="text-danger">
                *
              </abbr>
            </Form.Label>
            <Form.Control
              onChange={(e) => setSchemaName(e.target.value)}
              value={schemaName}
              className="br3"
              placeholder="Enter Schema Name"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">Kit Prefix</Form.Label>
            <Form.Control
              onChange={(e) => setKitPrefix(e.target.value)}
              value={kitPrefix}
              className="br3"
              placeholder="Enter Kit Prefix"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">Kit Starting Number <abbr className="text-danger">*</abbr></Form.Label>
            <Form.Control
              onChange={(e) => setKitStartingNumber(e.target.value)}
              value={kitStartingNumber}
              className="br3"
              placeholder="Enter Kit Starting Number"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">Kit Suffix</Form.Label>
            <Form.Control
              onChange={(e) => setKitSufix(e.target.value)}
              value={kitSufix}
              className="br3"
              placeholder="Enter Kit Suffix"
              type="text"
            />
          </Form.Group>
          <Form.Group className="mb-1">
            <Form.Label className="fw-bold mb-1">Kit Joiner</Form.Label>
            <Form.Select
              value={kitJoiner}
              onChange={(e) => setKitJoiner(e.target.value)}
            >
              <option value="">Select Kit Joiner</option>
              <option value="-">-</option>
              <option value="_">_</option>
              <option value="/">/</option>
              <option value="~">~</option>
              <option value="|">|</option>
            </Form.Select>
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm text-end">
          <button
            disabled={!schemaName || !kitStartingNumber || buttonLoader}
            className="updateProfile"
            onClick={(e) => updateEIWRSKitSchemaManagementData(e)}
          >
            {buttonLoader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Updating...
              </div>
            ) : (
              "Update Schema"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default UpdateStudyKitSchemaManagement;
